import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import faker from 'faker';
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false,
            text: 'Chart.js Line Chart',
        },
    },
    scales: {
        y: {
            grid: {
                color: '#B5B5C3'
            },
            border: {
                dash: [2, 2],
            },
            stacked: true
        },
        x: {
            grid: {
                drawOnChartArea: false,
                display: true,
                color: '#B5B5C3'
            },
            ticks: {
                stepSize: 0.5
            }
        }
    },
};

const labels = ['1 fev', '2 fev', '3 fev', '4 fev', '5 fev', '6 fev', '7 fev', '8 fev', '9 fev'];

const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: labels.map(() => faker.datatype.number({ min: -0, max: 100 })),
            borderColor: 'rgb(105,147,255)',
            backgroundColor: 'rgba(105,147,255, 0.15)',
            fill: true,
        }
    ],
};

const Chart3 = () => {

    return (
        <>
            <Card>
                <div className="chart-box-all">
                    <div>
                        <h4 className="title chart-title">Oqjar: <span>m<sup>3</sup>/s </span></h4>
                        <Line options={options} data={data} height={60} />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default Chart3;